































export default

	props:
		nutritionFacts: Array

	data: ->
		footnote1: "Not a significant source of cholesterol, dietary fiber, total sugars, added sugars, vitamin D, calcium, iron and potassium."
		footnote2: "*The % Daily Value tells you how much a nutrient in a serving of food contributes to a daily diet."

		filteredNutritionFacts: @nutritionFacts?.filter ({nutritionLabel}) -> !!nutritionLabel



	computed:
		servingSize: -> @filteredNutritionFacts?[0]

		tableContents: -> @filteredNutritionFacts.slice(1)

	methods:
		rowClass: ({rowType}) ->
			return "bold" unless rowType
			@toKabobCase rowType

		toKabobCase: (str) ->
			if str != str.toLowerCase()
				str = str.replace /[A-Z]/g, m => "-" + m.toLowerCase()
			return str

